import { z } from 'zod';
import { PopulatedUserSchema } from '../user/user.schema';
/** Sentinel actor id used when no authenticated user is in the CLS context. */ export const SYSTEM_ACTOR_ID = 'system';
export const AuditLogActionSchema = z.enum([
    'create',
    'update',
    'softDelete',
    'destroy',
    'bulkSoftDelete',
    'bulkDestroy',
    'bulkWrite'
]);
export const AuditLogChangeSchema = z.object({
    field: z.string(),
    from: z.unknown(),
    to: z.unknown()
});
export const AuditLogBatchInfoSchema = z.object({
    filter: z.record(z.string(), z.unknown()),
    update: z.record(z.string(), z.unknown()).nullable(),
    matchedCount: z.number(),
    modifiedCount: z.number()
});
export const AuditLogMetadataSchema = z.object({
    ip: z.string().optional(),
    userAgent: z.string().optional(),
    endpoint: z.string().optional()
});
export const AuditLogSchema = z.object({
    _id: z.string(),
    actorId: z.string(),
    action: AuditLogActionSchema,
    entityType: z.string(),
    entityId: z.string().nullable(),
    timestamp: z.iso.datetime(),
    changes: z.array(AuditLogChangeSchema).nullable(),
    snapshot: z.record(z.string(), z.unknown()).nullable(),
    batchInfo: AuditLogBatchInfoSchema.nullable(),
    sessionId: z.string().nullable(),
    metadata: AuditLogMetadataSchema.nullable()
});
export const AuditLogActorSchema = PopulatedUserSchema.pick({
    _id: true,
    firstName: true,
    lastName: true,
    email: true
});

//# sourceMappingURL=audit-log.schema.js.map